// Builds a Non-HC filter dropdown's option list ranked by total FY spend
// (largest first) instead of alphabetically, optionally scoped to records
// matching another already-selected field (e.g. Vendor Name scoped to the
// selected Sub-Category) — shared by every department's *Main.js filter bar.
// A value is dropped entirely when every record under it has zero Actual,
// Forecast, AOP, and Prior Year spend — Run Rate isn't checked separately
// since the backend derives it from those same actual/AOP figures, so it's
// already zero whenever they are.
export function optionsBySpend(records, field, scopeField, scopeValue) {
    // scopeValue is multi-select too (an array of selected values) — a
    // record is in scope if it matches ANY of them, same union rule as
    // every other multi-select filter; a plain string still works for any
    // caller that hasn't been converted.
    const scopeValues = Array.isArray(scopeValue) ? scopeValue : (scopeValue ? [scopeValue] : []);
    const scoped = scopeValues.length ? records.filter(row => scopeValues.includes(row[scopeField])) : records;
    const totals = new Map();
    const hasActivity = new Map();
    for (const row of scoped) {
        const key = row[field];
        if (!key) continue;
        const fy = row.fy_total || 0;
        const aop = row.aop_total || 0;
        const py = row.py_total || 0;
        totals.set(key, (totals.get(key) || 0) + fy);
        if (fy !== 0 || aop !== 0 || py !== 0) hasActivity.set(key, true);
    }
    return Array.from(totals.entries())
        .filter(([key]) => hasActivity.get(key))
        .sort((a, b) => b[1] - a[1])
        .map(([key]) => key);
}
